import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import util from 'preact-util';

// TODO: Do we need mobx? What is mobx doing here?

@observer
class FastListLine extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.containerRef = null;
    }

    componentWillUnmount() {
        const { removeIntersectionObserver, observeElement, obj } = this.props;
        if (removeIntersectionObserver) {
            removeIntersectionObserver(this.containerRef);
        }
        if (observeElement) {
            observeElement(obj, null);
        }
    }

    componentDidMount() {
        const { addIntersectionObserver, observeElement, obj } = this.props;
        if (addIntersectionObserver) {
            addIntersectionObserver(this.containerRef);
        }
        if (observeElement) {
            observeElement(obj, this.containerRef);
        }
    }

    componentDidUpdate(prevProps) {
        const { addIntersectionObserver, observeElement, obj } = this.props;
        // Observe new elements only after the observer is set up
        if (prevProps.intersectionObserver !== this.props.intersectionObserver) {
            addIntersectionObserver(this.containerRef);
        }
        if (observeElement && prevProps.obj !== obj) {
            observeElement(prevProps.obj, null);
            observeElement(obj, this.containerRef);
        }
    }

    render() {
        const {
            wrapperClassNames = '',
            contentClassNames = '',
            wrapperStyles = '',
            contentStyles = '',
            renderContent,
            obj = {},
            idx,
            dataFields,
            dataValues,
            sessionid,
            scrollSnap = false,
        } = this.props;

        const dataProperties = {};
        if (sessionid) {
            dataProperties.sessionid = sessionid;
        }
        dataFields.forEach(e => dataProperties[`data-${e}`] = encodeURI(dataValues[e] || obj[e]));

        return (
            <div
                class={`fastlist-wrapper ${wrapperClassNames} position-relative`}
                style={`
                    ${wrapperStyles}
                    ${scrollSnap ? 'scroll-snap-align: start;' : ''}
                `}
                ref={c => this.containerRef = c}
                data-idx={idx}
                {...dataProperties}
            >
                <div
                    class={`fastlist-content ${contentClassNames}`}
                    style={`display: block; ${contentStyles}`}
                >
                    {renderContent({
                        obj,
                        idx,
                    })}
                </div>
            </div>
        );
    }
}

@observer
class FastList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            observingRefs: [],
        };
    }

    // IntersectionObserver
    deleteIntersectionObserver = () => {
        this.intersectionObserver = null;
    }

    handleIntersection = (entries) => {
        const { handleIntersection } = this.props;
        if (typeof(handleIntersection) === 'function') {
            // console.log('handleIntersection:', handleIntersection);
            handleIntersection(entries);
        }
        // console.log({ entries });
        // TODO: Make it possible to run defined functions for entries.
        // mu.intersectionObserverCallback(entries);
        entries.forEach((e) => {
            const { isIntersecting } = e;
            const { height = 0 } = e.target.dataset;
            // const childHeight = e.target.childNodes[0].getBoundingClientRect().height;
            // const targetHeight = e.target.getBoundingClientRect().height;
            const childHeight = e.target.childNodes[0].offsetHeight;
            const targetHeight = e.target.offsetHeight;
            const scrollHeight = e.target.scrollHeight;
            const currentHeight = Math.floor(Math.max(childHeight, targetHeight, scrollHeight));
            // console.log({ isIntersecting, height, childHeight, targetHeight, scrollHeight, currentHeight }, e.target);

            if (isIntersecting) {
                e.target.childNodes[0].style.display=`block`;
                e.target.childNodes[0].classList.remove('fastlist-hide');
                // TODO: Should be set after image is loaded.
                // const height = e.target.childNodes[0].clientHeight > e.target.clientHeight ? e.target.childNodes[0].clientHeight : e.target.clientHeight;
                // console.log(e.target);
                // console.log('e.target.childNodes[0].offsetHeight:', e.target.childNodes[0].offsetHeight);
                // console.log('e.target.childNodes[0].scrollHeight:', e.target.childNodes[0].scrollHeight);
                // console.log('e.target.childNodes[0].clientHeight:', e.target.childNodes[0].clientHeight);
                // console.log('e.target.offsetHeight:', e.target.offsetHeight);
                // console.log('e.target.scrollHeight:', e.target.scrollHeight);
                // console.log('e.target.clientHeight:', e.target.clientHeight);
                // console.log('height:', height);
                // e.target.style.height=`${height}px`;
                e.target.style.minHeight = `${currentHeight > height ? currentHeight : height}px`;
            } else if (e.target.style.minHeight) {
                // e.target.style.height = `${currentHeight > height ? currentHeight : height}px`;
                e.target.style.minHeight = `${currentHeight > height ? currentHeight : height}px`;
                e.target.childNodes[0].style.display=`none`;
                e.target.childNodes[0].classList.add('fastlist-hide');
            }
        });
    }

    setupIntersectionObserver = () => {
        if (!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
            return false;
        }
        const appElement = document.getElementById('app');
        const options = {
            root: appElement, // this.viewportRef,
            rootMargin: '500px 500px 500px 500px',  // Trigger 300px before the element enters the viewport
            threshold: 0,
        };
        this.intersectionObserver = new IntersectionObserver(this.handleIntersection, options);
    }

    addIntersectionObserver = (ref) => {
        const { observingRefs } = this.state;
        // Check if ref is already being observed
        if (observingRefs.includes(ref)) {
            return;
        }
        if (this.intersectionObserver && ref) {
            this.intersectionObserver.observe(ref);
            observingRefs.push(ref);
        }
    }
    removeIntersectionObserver = (ref) => {
        const { observingRefs } = this.state;
        if (this.intersectionObserver && ref) {
            this.intersectionObserver.unobserve(ref);
            const idx = observingRefs.indexOf(ref);
            if (idx > -1) {
                observingRefs.splice(idx, 1);
            }
        }
    }

    componentDidMount() {
        // console.log('FastList componentDidMount', this.props.data[0]);
        this.setupIntersectionObserver();
    }

    componentWillUnmount() {
        this.deleteIntersectionObserver();
    }

    render() {
        const {
            data = [],
            containerWrapperClassNames = 'w-100',
            listWrapperClassNames = [],
            listWrapperClassNameFull,
            wrapperClassNames = 'row pb-4 bg-light',
            contentClassNames = `col-12 col-sm-8 col-lg-6 offset-sm-2 offset-lg-3 mb-0 position-relative rounded rounded-lg py-3 shadow-sm`,
            wrapperStyles = '',
            contentStyles = '',
            renderContent = () => <>Missing render function!</>,
            dataFields = [],
            dataValues = {},
            scrollSnap = false,
            observeElement,
        } = this.props;

        return (<>
            {/* <div
                class='fastlist-viewport position-fixed overflow-hidden'
                style={`
                    top: -500px;
                    left: -500px;
                    width: calc(100% + 1000px);
                    height: calc(100% + 1000px);
                    z-index: -1;
                `}
                ref={this.viewportRef}
            /> */}
            <div
                class={`${containerWrapperClassNames}`}
            >
                {data && data.filter(e => util.isObject(e)).map((obj, idx) => {
                    const hasWrapperClasses = Object.prototype.hasOwnProperty.call(obj, 'wrapperClassNames');
                    const hasContentClasses = Object.prototype.hasOwnProperty.call(obj, 'contentClassNames');
                    const wrapperClasses = hasWrapperClasses ? obj.wrapperClassNames : wrapperClassNames;
                    const contentClasses = hasContentClasses ? obj.contentClassNames : contentClassNames;
                    const wrapperClassNamesLine = listWrapperClassNames[idx] || listWrapperClassNameFull;
                    return (
                        <FastListLine
                            key={`fastline-${idx}-${obj.id}`}
                            obj={obj}
                            idx={idx}
                            intersectionObserver={this.intersectionObserver}
                            addIntersectionObserver={this.addIntersectionObserver}
                            removeIntersectionObserver={this.removeIntersectionObserver}
                            wrapperClassNames={`${wrapperClasses} ${wrapperClassNamesLine}`}
                            contentClassNames={contentClasses}
                            wrapperStyles={wrapperStyles}
                            contentStyles={contentStyles}
                            renderContent={renderContent}
                            dataFields={dataFields}
                            dataValues={dataValues}
                            scrollSnap={scrollSnap}
                            observeElement={observeElement}
                        />
                    );
                })}
            </div>
        </>);
    }
}

export default FastList;

/*
.bootstrap .fastlist-hide,
.bootstrap-dark .fastlist-hide {
	display: none !important;
}
*/
